import React, { useEffect, useState } from 'react';
import api from '../api';
import './Articles.css';

function Articles() {
  const [articles, setArticles] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const userEmail = localStorage.getItem('userEmail');
  const [newComment, setNewComment] = useState({});
  const [newRating, setNewRating] = useState({});

  useEffect(() => {
    fetchArticles();
  }, []);

  const fetchArticles = async () => {
    try {
      const res = await api.get('/articles');
      setArticles(res.data);
    } catch (err) {
      console.error('Erreur lors du chargement des articles :', err);
    }
  };

  const formatArticleContent = (text) => {
    if (!text) return '';

    // Si le contenu contient déjà du HTML (provenant de l'éditeur riche), le retourner tel quel
    if (/<[a-z][\s\S]*>/i.test(text)) {
      return text;
    }
  
    // Sinon, convertir le markdown (anciens articles)
    text = text
      .replace(/^# (.*)$/gm, '<h2>$1</h2>')
      .replace(/^## (.*)$/gm, '<h3>$1</h3>')
      .replace(/^(\d+)\. (.+)$/gm, '<h3>$1. $2</h3>')
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      .replace(/_(.*?)_/g, '<em>$1</em>');
  
    const paragraphs = text
      .split(/\n{2,}/)
      .map(p => `<p>${p.trim().replace(/\n/g, ' ')}</p>`);
  
    return paragraphs.join('');
  };
  

  const handleAddComment = async (articleId) => {
    if (!newComment[articleId] && !newRating[articleId]) return;

    try {
      await api.post(`/articles/${articleId}/comments`, {
        username: userEmail || 'Anonyme',
        content: newComment[articleId],
        rating: newRating[articleId] || 0
      });
      setNewComment({ ...newComment, [articleId]: '' });
      setNewRating({ ...newRating, [articleId]: 0 });
      fetchArticles();
    } catch (error) {
      console.error('Erreur lors de l’ajout du commentaire :', error);
    }
  };

  const renderStars = (note) =>
    '★'.repeat(Math.round(note)) + '☆'.repeat(5 - Math.round(note));

  const currentArticle = articles[currentIndex];

  return (
    <div className="articles-layout">
      <div className="article-main">
        {currentArticle && (
          <div className="article">
            <h3>{currentArticle.title}</h3>
            {currentArticle.imageUrl && (
              <img
                src={currentArticle.imageUrl}
                alt={currentArticle.title}
                className="article-image"
              />
            )}
            {/* <p>{currentArticle.content}</p> */}
            <div
                className="formatted-article"
                dangerouslySetInnerHTML={{ __html: formatArticleContent(currentArticle.content) }}
                />



            <div className="article-rating">
              <strong>Note moyenne :</strong>{' '}
              <span style={{ color: '#f4a100' }}>{renderStars(currentArticle.rating)}</span>{' '}
              ({currentArticle.rating.toFixed(1)}/5)
            </div>

            <h4>Commentaires :</h4>
            <ul className="comment-list">
              {currentArticle.comments.map((c, idx) => (
                <li key={idx}>
                  <strong>{c.username}</strong> ({renderStars(c.rating || 0)}): {c.content}
                </li>
              ))}
            </ul>

            <div className="comment-form">
              <select
                value={newRating[currentArticle._id] || 0}
                onChange={(e) =>
                  setNewRating({ ...newRating, [currentArticle._id]: parseFloat(e.target.value) })
                }
              >
                <option value={0}>Note</option>
                {[1, 2, 3, 4, 5].map((n) => (
                  <option key={n} value={n}>
                    {n} étoile{n > 1 ? 's' : ''}
                  </option>
                ))}
              </select>

              <input
                type="text"
                placeholder="Laissez un commentaire"
                value={newComment[currentArticle._id] || ''}
                onChange={(e) =>
                  setNewComment({ ...newComment, [currentArticle._id]: e.target.value })
                }
              />
              <button onClick={() => handleAddComment(currentArticle._id)}>Envoyer</button>
            </div>

            <div className="article-navigation">
              <button onClick={() => setCurrentIndex((prev) => Math.max(prev - 1, 0))} disabled={currentIndex === 0}>
                ◀ Précédent
              </button>
              <span>{currentIndex + 1} / {articles.length}</span>
              <button
                onClick={() => setCurrentIndex((prev) => Math.min(prev + 1, articles.length - 1))}
                disabled={currentIndex === articles.length - 1}
              >
                Suivant ▶
              </button>
            </div>
          </div>
        )}
      </div>

      <div className="article-sidebar">
        <h4>Autres articles</h4>
        <ul>
          {articles.map((article, idx) => (
            <li key={article._id}>
              <button onClick={() => setCurrentIndex(idx)} disabled={idx === currentIndex}>
                {article.title.length > 40 ? article.title.slice(0, 40) + '...' : article.title}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Articles;
